var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanFemaleBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4.5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM3 20v-6H0l2.6-7.6c.3-.8 1-1.4 1.9-1.4.9 0 1.7.6 1.9 1.4L9 14H6v6H3zm8.5-10a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm-1 3h6v4H15v3h-3v-3h-1.5v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanFemaleBoy);
export default __webpack_public_path__ + "static/media/human-female-boy.c05b9c399616a6be667825bcdcb1464f.svg";
export { ForwardRef as ReactComponent };